// Desktop mega menu: hover-driven (the top-level element is a hub link, so
// click navigates). Keyboard users get the same panels via focus; Esc closes.
import { onEscape } from './dismiss.js';

const CLOSE_DELAY = 150;

function closeNiches(panel) {
  panel.querySelectorAll('[data-megamenu-niche-toggle][aria-expanded="true"]').forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false');
    const niche = document.getElementById(btn.getAttribute('aria-controls'));
    if (niche) niche.classList.remove('is-open');
  });
}

export function initMegamenu() {
  const closers = [];

  document.querySelectorAll('[data-megamenu]').forEach((item) => {
    const link = item.querySelector('[data-megamenu-link]');
    const panelId = link ? link.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!link || !panel) return;

    let closeTimer = null;

    const setOpen = (open) => {
      panel.classList.toggle('is-open', open);
      link.setAttribute('aria-expanded', String(open));
      if (!open) closeNiches(panel);
    };
    closers.push(() => setOpen(false));

    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      setOpen(true);
    });
    item.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => setOpen(false), CLOSE_DELAY);
    });
    item.addEventListener('focusin', () => setOpen(true));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(false);
    });

    panel.querySelectorAll('[data-megamenu-niche-toggle]').forEach((btn) => {
      const niche = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (!niche) return;
      const openNiche = () => {
        closeNiches(panel);
        btn.setAttribute('aria-expanded', 'true');
        niche.classList.add('is-open');
      };
      btn.addEventListener('mouseenter', openNiche);
      btn.addEventListener('focus', openNiche);
      // Touch devices have no hover; a tap opens the niche instead.
      btn.addEventListener('click', openNiche);
    });
  });

  onEscape(() => closers.forEach((close) => close()));
}
